const COMMON_FLOW_STEPS = {
  NEED_MORE_DATA_STEP: 'needMoreData',
  MANUAL_REVIEW_STEP: 'manualReview',
  DENIED_STEP: 'denied',
}

const ACTIVATE_CARD_FLOW_STEPS = {
  CARD_NOT_DELIVERED_STEP: 'cardNotDelivered',
  ENTER_CVV_STEP: 'enterCvv',
  CREATE_PIN_STEP: 'createPin',
  DOB_SSN_STEP: 'dobSsn',
  CARD_NOT_RECEIVED_STEP: 'cardNotReceived',
  CONFIRM_INFO_STEP: 'confirmingInfo',
  ACTIVATE_SUCCESS_STEP: 'activateSuccess',
  INELIGIBLE_STEP: 'ineligible',
  ...COMMON_FLOW_STEPS,
}

const REPLACE_CARD_FLOW_STEPS = {
  CHOOSE_REASON_STEP: 'chooseReason',
  REPLACE_LOST_OR_STOLEN_STEP: 'reportLostStolen',
  REPLACE_NAME_CHANGE_STEP: 'replaceNameChange',
  REPLACE_REISSUE_STEP: 'replaceReissue',
  REPLACE_LOADING_STEP: 'replaceLoading',
  REPLACE_SUCCESS_STEP: 'replaceSuccess',
  DENIED_STEP: 'denied',
}

const BDMC_CANCEL_CARD_FLOW_STEPS = {
  CANCEL_REASON_STEP: 'cancelReason',
  CASH_BACK_REWARDS_STEP: 'cashBackRewards',
  MONEY_IN_ACCOUNT_STEP: 'moneyInAccount',
  DECLINED_TRANSACTIONS_STEP: 'declinedTransactions',
  MOVED_TO_MANAGED_PAYMENTS_STEP: 'movedToManagedPayments',
  OTHER_REASON_STEP: 'otherReason',
  CASH_BACK_OFFER_STEP: 'cashBackOffer',
  CANCEL_SUCCESS_STEP: 'cancelSuccess',
  CANCEL_TRY_AGAIN_STEP: 'cancelTryAgain',
  CANCEL_CALL_US_STEP: 'cancelCallUs',
  CASH_BACK_ENROLLED_STEP: 'cashBackEnrolled',
  CASH_BACK_ENROLL_ERROR_STEP: 'cashBackEnrollError',
}

const CHANGE_ADDRESS_FLOW_STEPS = {
  CHOOSE_ADDRESS_STEP: 'chooseAddress',
  ADD_ADDRESS_STEP: 'addAddress',
  NORMALIZED_ADDRESS_STEP: 'normalizedAddress',
  INVALID_ADDRESS_STEP: 'invalidAddress',
  ADD_ADDRESS_ERROR_STEP: 'addAddressError',
  BDMC_UPDATE_OTHER_CARDS_STEP: 'bdmcUpdateOtherCards',
}

const SET_PIN_FLOW_STEPS = {
  SET_PIN_INTRO_STEP: 'setPinIntro',
  SET_PIN_STEP: 'setPin',
  SET_PIN_SUCCESS_STEP: 'setPinSuccess',
  SET_PIN_DENIED_STEP: 'setPinDenied',
}

const STATIC_PAGE_FLOW_STEPS = {
  SHOW_CONTENT_STEP: 'showContent',
  PAGE_NOT_FOUND_STEP: 'pageNotFound',
}

const ENROLL_CARD_FLOW_STEPS = {
  ELIGIBLE_STEP: 'eligibleLanding',
  INELIGIBLE_STEP: 'ineligible',
  CARD_ENROLLING_STEP: 'cardEnrolling',
  BDMC_XSELL_STEP: 'bdmcCrossSell',
  CARD_SUCCESS_STEP: 'cardSuccess',
  FUNDING_INSTRUMENT_STEP: 'fundingInstrument',
  ...COMMON_FLOW_STEPS,
}

const SETUP_FI_STEPS = {
  CHOOSE_FI_STEP: 'chooseFi',
  ADD_FI_STEP: 'addFi',
  RISK_STEPUP_STEP: 'riskStepUp',
  RISK_DECLINE_STEP: 'riskDecline',
}

const MANAGE_CARD_FLOW_STEPS = {
  CARD_DETAILS: 'cardDetails',
}

const SHOW_CARD_FLOW_STEPS = {
  SHOW_CARD_SUCCESS_STEP: 'showCardSuccess',
  SHOW_CARD_DENIED_STEP: 'showCardDenied',
}

const REQUEST_PHYSICAL_CARD_FLOW_STEPS = {
  REQUEST_PHYSICAL_CARD_INTRO_STEP: 'requestPhysicalCardIntro',
  REQUEST_PHYSICAL_CARD_STEP: 'requestPhysicalCard',
  REQUEST_PHYSICAL_CARD_WITH_FEE_STEP: 'requestPhysicalCardWithFee',
}

const REWARDS_FLOW_STEPS = {
  REWARDS_HUB: 'rewardsHub',
}

const PAYROLL_PARTNER_STEPS = {
  PAYROLL_PARTNER_ERROR: 'payrollPartnerError',
}

const XO_PPDC_STEP = {
  PPDC_UPSELL_XO: 'ppdcUpsellXO',
}

export const FLOW_STEPS = {
  COMMON: COMMON_FLOW_STEPS,
  ACTIVATE: ACTIVATE_CARD_FLOW_STEPS,
  REPLACE_CARD: REPLACE_CARD_FLOW_STEPS,
  BDMC_CANCEL_CARD: BDMC_CANCEL_CARD_FLOW_STEPS,
  CHANGE_ADDRESS: CHANGE_ADDRESS_FLOW_STEPS,
  SET_PIN: SET_PIN_FLOW_STEPS,
  STATIC_PAGE: STATIC_PAGE_FLOW_STEPS,
  ENROLL_CARD: ENROLL_CARD_FLOW_STEPS,
  MANAGE_CARD: MANAGE_CARD_FLOW_STEPS,
  SHOW_CARD: SHOW_CARD_FLOW_STEPS,
  REWARDS: REWARDS_FLOW_STEPS,
  PAYROLL_PARTNER: PAYROLL_PARTNER_STEPS,
  REQUEST_PHYSICAL_CARD: REQUEST_PHYSICAL_CARD_FLOW_STEPS,
  SETUP_FI: SETUP_FI_STEPS,
  XO_PPDC: XO_PPDC_STEP,
}
